import { render, staticRenderFns } from "./memberInfoComponent.vue?vue&type=template&id=226cb0a6&"
import script from "./memberInfoComponent.vue?vue&type=script&lang=ts&"
export * from "./memberInfoComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports